import { useEffect, useState } from "react";
import { BankDetails, EditButton, ToggleButton } from "../../components";

const BankDetailsForm = ({ id, isCurrentStep }) => {
  const [current, setCurrent] = useState(isCurrentStep);
  const [showForm, setShowForm] = useState(isCurrentStep);
  const [bankData, setBankData] = useState({
    project_bank_details: {},
    aurus_commission_bank_details: {},
    development_bank_details: {},
    registration_bank_details: {},
  });
  const [newProjectName, setNewProjectName] = useState("");

  useEffect(() => {
    if (!isCurrentStep) return;
    const savedData = JSON.parse(localStorage.getItem("new_project_data"));
    if (savedData) setNewProjectName(savedData.project_name);
  }, [isCurrentStep]);

  const [projectBankDetailsEditable, setProjectBankDetailsEditable] = useState(false);

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData) setBankData(savedData);
  }, [id]);

  useEffect(() => {
    setShowForm(isCurrentStep);
    setCurrent(isCurrentStep);
  }, [isCurrentStep]);

  const handleSaveBankDetails = (data, key) => {
    setBankData((prev) => ({ ...prev, [key]: data }));
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData) localStorage.setItem(id, JSON.stringify({ ...savedData, [key]: data }));
    else localStorage.setItem(id, JSON.stringify({ [key]: data }));
  };

  const handleEditBankDetails = (data, key) => {
    const prevData = bankData[key];
    setBankData((prev) => ({ ...prev, [key]: { ...prevData, ...data } }));
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData) localStorage.setItem(id, JSON.stringify({ ...savedData, [key]: { ...prevData, ...data } }));
    else localStorage.setItem(id, JSON.stringify({ [key]: { ...prevData, ...data } }));
  };

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData) setBankData(savedData);
  }, []);

  const handleIdentificationUpload = (imageId, url, key) => {
    const prevData = bankData[key];
    setBankData((prev) => ({
      ...prev,
      [key]: { ...prevData, bank_identification: imageId, bank_identification_url: url },
    }));
    const savedData = JSON.parse(localStorage.getItem(id));
    if (savedData)
      localStorage.setItem(
        id,
        JSON.stringify({
          ...savedData,
          [key]: { ...prevData, bank_identification: imageId, bank_identification_url: url },
        })
      );
    else
      localStorage.setItem(
        id,
        JSON.stringify({ [key]: { ...prevData, bank_identification: imageId, bank_identification_url: url } })
      );
  };

  return (
    <>
      <section className="section_wrapper">
        <section className="section_title_wrapper">
          <h3 className="section_title">{newProjectName ? newProjectName : "Project"} Bank Details</h3>
          {current ? <EditButton onClick={() => setProjectBankDetailsEditable(true)} disabled={!current} /> : ""}
          <ToggleButton open={showForm} onClick={() => setShowForm((showForm) => !showForm)} />
        </section>
        <section className={`section_wrapper ${showForm ? "" : "hide"}`}>
          <BankDetails
            parentName="Project"
            showTitle={false}
            disableInputs={!current}
            handleAdd={(data) => handleSaveBankDetails(data, "project_bank_details")}
            handleEdit={(data) => handleEditBankDetails(data, "project_bank_details")}
            handleIdentificationUpload={(data, url) => handleIdentificationUpload(data, url, "project_bank_details")}
            data={bankData.project_bank_details}
            id="project_bank_details"
            isEditable={projectBankDetailsEditable}
            cancelEdit={() => setProjectBankDetailsEditable(false)}
            formId={id}
          />
          <BankDetails
            parentName="Company"
            title="Aurus Group Bank Details"
            titleSmall="(for commission)"
            showEditButton={current}
            disableInputs={!current}
            id="aurus_commission_bank_details"
            handleAdd={(data) => handleSaveBankDetails(data, "aurus_commission_bank_details")}
            handleEdit={(data) => handleEditBankDetails(data, "aurus_commission_bank_details")}
            data={bankData.aurus_commission_bank_details}
            handleIdentificationUpload={(data, url) =>
              handleIdentificationUpload(data, url, "aurus_commission_bank_details")
            }
            formId={id}
          />
          <BankDetails
            parentName="Company"
            title="Bank Account Details for Development Charges"
            showEditButton={current}
            disableInputs={!current}
            id="development_bank_details"
            handleAdd={(data) => handleSaveBankDetails(data, "development_bank_details")}
            handleEdit={(data) => handleEditBankDetails(data, "development_bank_details")}
            data={bankData.development_bank_details}
            handleIdentificationUpload={(data, url) =>
              handleIdentificationUpload(data, url, "development_bank_details")
            }
            formId={id}
          />
          <BankDetails
            parentName="Company"
            title="Bank Account Details for Registration Charges"
            showEditButton={current}
            disableInputs={!current}
            id="registration_bank_details"
            handleAdd={(data) => handleSaveBankDetails(data, "registration_bank_details")}
            handleEdit={(data) => handleEditBankDetails(data, "registration_bank_details")}
            data={bankData.registration_bank_details}
            handleIdentificationUpload={(data, url) =>
              handleIdentificationUpload(data, url, "registration_bank_details")
            }
            formId={id}
          />
        </section>
      </section>
    </>
  );
};
export default BankDetailsForm;
